import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Auth, API } from 'aws-amplify';
import './SignIn.css';
import useApi from '..//hooks/useApi';
import { useLocation } from 'react-router-dom';

const SignIn = ({ setLoading }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { apiGet } = useApi(); // Destructure apiGet from useApi

  const getUserProjects = async (data) => {
    return data?.projects?.map(project => project.name) || [];
  }

  const location = useLocation();
  const userData = location.state?.userData;
  const getUserRoles = async (userData) => {

    const all_roles_keys = userData?.projects?.map(project => Object.keys(project.roles));
    const all_roles_keys_flat = all_roles_keys.flat();
    const all_roles_keys_flat_lower = all_roles_keys_flat.map(role => role.toLowerCase());
    return all_roles_keys_flat_lower;
  }

  function getProjectPages(response, projectName) {
    const project = response?.projects.find(proj => proj.name === projectName);
    if (!project) return [];
    const pages = Object.values(project.roles)
      .flatMap(role => role.pages);
    return [...new Set(pages)];
  }
  const handleSignIn = async (e) => {
    console.log("handleSignIn");
    e.preventDefault();
    setError('');
    try {
      setLoading(true);
      await Auth.signIn(email, password);
      localStorage.setItem('useremail', email);
      const response = await apiGet("UX_HTTP_API", "/get-user-info");
      if (response?.projects) {
        const projectNames = await getUserProjects(response);
        localStorage.setItem('allowedProjects', JSON.stringify(projectNames));
        console.log("projectNames", projectNames);
        if (projectNames.length === 0) {
          setError('No projects assigned to this user.');
        } else if (projectNames.length === 1) {
          const projectName = projectNames[0];
          const all_roles_keys_flat_lower = await getUserRoles(response);
          let allowedPages = getProjectPages(response, projectName);

          /* localStorage.setItem('selectedProject', 'esid-24-003');
          localStorage.setItem('allowedProjects', JSON.stringify(['esid-24-003']));
          localStorage.setItem('all_roles', JSON.stringify(['operator']));
          localStorage.setItem('allowedPages', JSON.stringify(['/esid-24-003/reports', '/esid-24-003/dashboard'])); */
          localStorage.setItem('selectedProject', projectName);
          localStorage.setItem('allowedProjects', JSON.stringify(projectNames));
          localStorage.setItem('all_roles', JSON.stringify(all_roles_keys_flat_lower));
          localStorage.setItem('allowedPages', JSON.stringify(allowedPages));
          navigate(`/${projectName}/dashboard`);
        } else {
          navigate('/project-selection', { state: { userData: response } });
        }
      } else {
        setError('Unable to fetch user projects. Server response was empty.');
      }
    } catch (err) {
      console.error('Sign in error:', err);
      if (err.name === 'NotAuthorizedException') {
        setError('Invalid credentials. Please try again.');
      } else if (err.name === 'UserNotFoundException') {
        setError('User not found. Please check your email.');
      } else if (err.name === 'UserNotConfirmedException') {
        setError('Please confirm your email before signing in.');
      } else {
        setError(`Authentication error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };




  return (
    <div className="signin-wrapper">
      <div className="signin-container">
        <div className="signin-header">
          <h2>Welcome Back</h2>
          <p>Please sign in to your account</p>
        </div>

        <form onSubmit={handleSignIn}>
          {error && (
            <div className="error-message">
              <i className="fas fa-exclamation-circle"></i>
              {error}
            </div>
          )}



          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <div className="input-container">
              <i className="fas fa-envelope"></i>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-container">
              <i className="fas fa-lock"></i>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>
          </div>

          <button type="submit" className="signin-button">
            Sign In
          </button>
          <div className="signin-footer">
            <p>Don't have an account? <Link to="/signup">Sign Up</Link></p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignIn;